import { render, staticRenderFns } from "./PublicUpdate.vue?vue&type=template&id=51ae39ca&"
import script from "./PublicUpdate.vue?vue&type=script&lang=js&"
export * from "./PublicUpdate.vue?vue&type=script&lang=js&"
import style0 from "./PublicUpdate.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports